import { style } from '@vanilla-extract/css'

const card = style({
  color: '#E46327',
  backgroundColor: 'transparent',
  border: '2px solid #E46327',
  borderRadius: '8px',
  padding: '16px',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  gap: '2px',
})

const heading = style({
  fontSize: '13px',
  fontWeight: '700',
  lineHeight: '1.5',
  letterSpacing: '0.02em',
})

const list = style({
  fontSize: '13px',
  lineHeight: '1.5',
  letterSpacing: '0.02em',
  listStyleType: 'disc',
  paddingLeft: '1em',
})

const listItem = style({
  selectors: {
    '&::marker': {
      content: "・",
    },
  },
})

export const styles = {
  card,
  heading,
  list,
  listItem,
}
